var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
var Pagination = function (_a) {
    var typeResultText = _a.typeResultText, displayElements = _a.displayElements, _b = _a.total, total = _b === void 0 ? 0 : _b, pageSize = _a.pageSize;
    var navigateTo = useNavigateTo();
    var filters = useFilters();
    var location = useLocation();
    var currentPage = filters.page || 1;
    var t = useTranslation().t;
    var clickPreviousPage = function () {
        navigateTo({
            pathname: location.pathname,
            newFilters: { page: currentPage - 1 }
        });
    };
    var clickNextPage = function () {
        navigateTo({
            pathname: location.pathname,
            newFilters: { page: currentPage + 1 }
        });
    };
    return (_jsxs("nav", __assign({ className: " px-4 py-3 flex items-center justify-between  sm:px-6", "aria-label": "Pagination" }, { children: [_jsx("div", __assign({ className: "hidden sm:block pt-2" }, { children: _jsx("span", __assign({ className: "text-sm text-gray-700 text-center" }, { children: displayElements !== 0 ? (_jsxs("span", { children: [_jsxs("span", { children: [" ", t('pagination.showing'), " "] }), ' ', _jsx("span", __assign({ className: "font-medium" }, { children: currentPage * pageSize - (pageSize - 1) })), ' ', t('pagination.to'), ' ', _jsx("span", __assign({ className: "font-medium" }, { children: currentPage * pageSize - (pageSize - 1) + displayElements - 1 })), ' ', t('pagination.of'), " ", _jsx("span", __assign({ className: "font-medium" }, { children: total })), ' ', _jsx("span", __assign({ className: "lowercase" }, { children: typeResultText }))] })) : (_jsx("div", { className: "h-6" })) })) })), _jsxs("div", __assign({ className: " flex justify-between sm:justify-end" }, { children: [currentPage !== 1 ? (_jsx(Button, __assign({ variant: "white", onClick: clickPreviousPage }, { children: t('pagination.previous') }))) : null, currentPage * pageSize < total ? (_jsx(Button, __assign({ variant: "white", onClick: clickNextPage, className: "ml-3" }, { children: t('pagination.next') }))) : null] }))] })));
};
export default Pagination;
